export default [
  { id: 'date', label: 'Date' },
  { id: 'steps', label: 'Steg' },
  { id: 'training', label: 'Training' },
  { id: 'restingHeartRate', label: 'Hjärtfrekvens' },
  { id: 'stressSmartWatch', label: 'Stress from smartwatch' },
  { id: 'sleepSmartWatch', label: 'Sleep from smartwatch' },
];
